import Resource from './Resource';

/**
 * Location Resource
 */
class Location extends Resource
{
    constructor() {
        super('location', ['locations']);
    }
}   

export let LocationResource = new Location();

/**
 * LocationSchema
 * @param {Object} defaults [description]
 */
export let LocationSchema = function(defaults = {}) {
    let schema = {
        id: null,
        name: null, 
        email: null,
        website: null,
        created_by_id: null, 
        has_showroom: false,
        sales_calendars: [],
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}